import { render } from "./RegisterPinEnrollView.vue?vue&type=template&id=2a1c7b8c"
import script from "./RegisterPinEnrollView.vue?vue&type=script&lang=js"
export * from "./RegisterPinEnrollView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__